<template>
  <section id="file-list" class="">
    <div v-if="file" class="single">
      <File :file="file" :type="this.type"></File>
    </div>
    <div
      v-else
      class="list"
      :class="{ col5: col == 5, col3: col == 3, col4: col == 4 }"
    >
      <div
        v-if="Object.keys(files).length > 0"
        class="files-container"
        :class="{ new: type == 'new' }"
      >
        <template v-for="(item, index) in files">
          <div
            v-if="item.sections[0] != undefined && item.sections[0].type >= 4"
            class="item special"
          >
            <div class="img-cnt">
              <img :src="item.thumb + '?' + date(item.update_date)" />
            </div>
            <div class="format">{{ item.sections[0].name }}</div>
            <div class="name">{{ item.name }}</div>
            <a
              v-if="item.download != 0"
              v-on:click.stop
              :href="domain_url + item.id + '/' + user_id"
              class="bttn download"
              target="_blank"
            >
              <div class="icon"></div>
              <span>{{ $t('general.download') }}</span>
            </a>
          </div>

          <div
            v-else
            class="item"
            :href="item.url"
            :key="item.id"
            v-show="language.includes(item.lang.name)"
            @click="select(item)"
          >
            <div class="img-cnt">
              <img :src="item.thumb + '?' + date(item.update_date)" />
            </div>
            <div class="format">{{ item.type.name }}</div>
            <div class="name">{{ item.name }}</div>

            <template v-if="type != 'new'">
              <a
                v-on:click.stop
                :href="domain_url + item.id + '/' + user_id"
                class="bttn download"
                target="_blank"
                v-if="item.file != '' && item.download != 0"
              >
                <div class="icon"></div>
                <span>{{ $t('general.download') }}</span>
              </a>
              <!-- HARCODED CATEGORIES THAT ARE NOT ADAPTABLE -->
              <div
                v-if="
                  item.file != '' &&
                    !(
                      currentCategory.includes('legal1') ||
                      currentCategory.includes(
                        'aspectoslegalesdelapublicidad'
                      ) ||
                      currentCategory.includes('instalacionespublicitarias')
                    )
                "
                v-on:click.stop
                @click="order(item)"
                class="bttn order"
              >
                <div class="icon"></div>
                <span>{{ $t('files.file.adaptation') }}</span>
              </div>
              <div
                v-if="item.budget == 1"
                v-on:click.stop
                @click="cart(item)"
                class="bttn production"
              >
                <div class="icon"></div>
                <span>{{ $t('files.file_list.production') }}</span>
              </div>
              <div v-else class="production"></div>
            </template>
            <template v-else>
              <div class="uploaded-date">
                {{ market === 'PT' ? parseDateRelative(item.created_date) : parseDateRelative(item.update_date) }}
              </div>
            </template>
          </div>
        </template>
      </div>
      <div v-else class="empty">
        {{ $t('general.soon') }}
      </div>
    </div>
  </section>
</template>

<script>
import File from "@/components/domain/files/File";

export default {
  props: { type: [Number, String], search: String, col: Number },
  components: { File },
  data() {
    return {
      domain_url: window.location.origin + "/r/"
    };
  },
  computed: {
    user_id() {
      var data = this.$store.getters["user/getUser"];
      return data.id;
    },
      language() {
        const lang = this.$store.state.language;
        return [lang];
      },
    files() {
      if (this.search) {
        var self = this;
        //this.$store.commit('setLoading', true);
        return self.$store.getters["files/searchFiles"];
      } else if (this.type == "new") {
        var files = this.$store.getters["files/getNewFiles"];
        return Object.values(files)
          .sort((a, b) => new Date(b.created_date) - new Date(a.created_date))
          .slice(0, 10);
      } else {
        return this.$store.getters["files/getFiles"](
          this.$store.getters["files/getCurrentCategory"]
        );
      }
    },
    file() {
      return this.$store.getters["files/getCurrentFile"];
    },
    not_admin() {
      return !this.$store.getters["user/isAdmin"];
    },
    currentCategory() {
      return this.$route.path;
    },
    market() {
      return this.$store.getters.getMarket;
    }
  },
  methods: {
    //  NEW FILES METHODS
    parseDateRelative(date) {
      if (this.market === 'PT') {
        moment.locale('pt')
        return moment(date).fromNow();
      } else {
        return moment(date).fromNow();
      }
    },

    // GENERAL METHODS
    select(item) {
      console.log('item', item);
      if (this.search) {
        if (typeof item.sections[0] != "undefined") {
          var type = "";
          if (item.sections[item.sections.length - 1].type == "1") type = "nacional";
          else if (item.sections[item.sections.length - 1].type == "2") type = "local";
          else if (item.sections[item.sections.length - 1].type == "3") type = "comunicacion";

          this.$router.push(
            "/" + type + "/" + item.sections[item.sections.length - 1].url + "/" + item.url
          );
        }
      } else if (this.type == "new") {
        var type = "";
        if (item.sections[item.sections.length - 1].type == "1") type = "nacional";
        else if (item.sections[item.sections.length - 1].type == "2") type = "local";
        else if (item.sections[item.sections.length - 1].type == "3") type = "comunicacion";
        console.log("/" + type + "/" + item.sections[0].url + "/" + item.url);
        // this.$store.commit('files/setCurrentFile', item);
        this.$router.push(
          "/" + type + "/" + item.sections[item.sections.length - 1].url + "/" + item.url
        );
      } else {
        this.$store.commit("files/setCurrentFile", item);
      }
    },
    order(item) {
      console.log(item);
      this.$store.commit("files/setCurrentFile", item);
      this.$router.push("/order/" + item.id);
    },
    cart(item) {
      console.log(item);
      var order = {
        from: { file: item.id, filename: item.name, image: item.thumb },
        to: { file: false, filename: false, size: "" },
        method: 2,
        units: false,
        billed: false,
        shipped: false,
        custom_ship: "",
        custom: "",
        custom_file: null,
        params: {}
      };

      this.$store.commit("orders/addOrderToCart", order);
      this.$store.commit("files/unsetCurrentFile");
      this.$router.push({ name: "cart" });
    },
    date(date) {
      return moment(date).valueOf();
    },

    checkLang() {
      if (this.market === 'PT') {
        var result = Object.values(this.files).find(obj => {
          return obj.lang.name === "PT";
        });
      } else {
        var result = Object.values(this.files).find(obj => {
          return obj.lang.name === "CAT";
        });
      }
      if (result != undefined) {
        this.$emit("uniqueLang", true);
      } else {
        this.$emit("uniqueLang", false);
      }
    }
  },
  mounted() {
    // console.log( "MOUNTED");
    if (this.search) {
      //   console.log( "SEARCH" );
      this.$store
        .dispatch("files/searchFiles", { search: this.search })
        .then(function() {});
    } else if (this.$store.getters["files/getCurrentCategory"]) {
      // console.log( this.$store.getters['files/getCurrentCategory'] );
      // var params = {
      //   id: this.$store.getters['files/getCurrentCategory']
      // };
      // this.$store.dispatch('files/loadFiles', params).then(function() {
      //   //this.loading = false;
      // })
    } else {
      //   console.log( "ELSE")
    }
  },
  watch: {
    files() {
      this.checkLang();
    }
  },
  created() {
    // if(this.search) {
    //     var self = this;
    //     this.$store.dispatch('files/searchFiles', {search: this.search}).then(function() {
    //         self.$store.commit('setLoading', false);
    //         console.log( self.$store.getters['files/searchFiles'] );
    //         return self.$store.getters['files/searchFiles'];
    //     });
    // }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#file-list {
  padding: 10px;
  overflow: hidden;
  width: 100%;

  .col5 {
    .item {
      width: 20%;
    }
  }

  .item {
    width: 25%;
    max-width: 250px;
    display: inline-block;
    float: left;
    padding: 20px;
    text-align: left;
    cursor: pointer;
    margin-bottom: 20px;
    height: 450px;

    &.special {
      cursor: initial;
    }

    .img-cnt {
      text-align: center;
      width: 90%;
      margin-bottom: 5px;
      max-height: 200px;
      min-height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      img {
        max-height: 200px;
        max-width: 200px;
        object-position: center;
      }
    }

    .format {
      font-size: 10pt;
      color: #666;
      margin-bottom: 5px;
      min-height: 20px;
      height: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .name {
      font-size: 11pt;
      height: auto;
      max-height: 60px;
      overflow: hidden;
      margin-bottom: 10px;
    }

    .uploaded-date {
      font-size: 11pt;
      height: auto;
      max-height: 60px;
      overflow: hidden;
      color: #777;
      // margin-bottom: 10px;
    }

    .bttn {
      width: 100%;
      overflow: hidden;
      margin-bottom: 5px;
      line-height: 30px;
      cursor: pointer;
      display: block;
      color: #333;

      .icon {
        width: 30px;
        height: 30px;
        background: #ccc;
        display: inline-block;
        float: left;
      }
      span {
        display: inline-block;
        float: left;
        padding-left: 5px;
        font-size: 11pt;

        &:hover {
          font-family: Speedee-Bold;
        }
      }
      &.download {
        border-top: 2px solid var(--main_color);

        .icon {
          background: url(/img/download.svg) no-repeat center var(--main_color);
          background-size: 18px;
        }
      }
      &.order {
        border-top: 2px solid #ccc;
        .icon {
          background: url(/img/edit.svg) no-repeat center #ccc;
          background-size: 18px;
        }
      }
      &.production {
        border-top: 2px solid #ccc;
        .icon {
          background: url(/img/box.svg) no-repeat center #ccc;
          background-size: 18px;
        }
      }
    }
    .production {
      min-height: 30px;
    }
  }

  .empty {
    font-size: 17px;
    margin-top: 100px;
    color: #999;
  }

  .files-container.new {
    height: auto;
    width: 74%;
    margin: 0 auto;

    .item {
      height: 300px;
      width: 20%;
      max-width: 250px;

      .img-cnt {
        height: 200px;
        max-height: 200px;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      
      .name {
        height: 40px;
        overflow: hidden;
      }
      
      .uploaded-date {
        height: 40px;
        margin-top: 10px;
      }
    }
  }
}
</style>
